var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var WaterDropIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "a" },
            React.createElement("path", { d: "M8 0c5.33 4.55 8 8.48 8 11.8 0 4.98-3.8 8.2-8 8.2s-8-3.22-8-8.2C0 8.48 2.67 4.55 8 0ZM3.83 12a.75.75 0 0 0-.74.87c.57 3.03 3.06 4.25 5.19 4.12.4-.02.72-.35.72-.75 0-.43-.36-.77-.79-.75-1.36.11-3.23-.65-3.64-2.87a.75.75 0 0 0-.74-.62Z" }))),
    React.createElement("g", { "clip-path": "url(#a)", transform: "translate(4 2)" },
        React.createElement("path", { fill: "currentColor", d: "M0 0h16v20H0V0z" })))); };
export default WaterDropIcon;
